// THE single source for every price shown on the site: /pricing, PricingCompare, the
// sign-up copy, landing/campaign pages, account plan pickers and the SEO titles in
// routeMeta.js. Change a number here and every page follows - never hard-code "£9.99".
// Format with formatPrice(), which gives "£9.99".
//
// No imports and no import.meta.env on purpose: vite.config.js loads this (via
// routeMeta.js) in plain Node at build time, as well as the SSR bundle and the browser.
//
// KEEP IN SYNC with the Stripe prices the Plan step actually charges
// (VITE_STRIPE_LIGHT_USER_MONTHLY_PRICE_ID / VITE_STRIPE_LIGHT_USER_YEARLY_PRICE_ID) -
// that step reads the live amount from Stripe, everything else reads these.
export const MONTHLY_PRICE = 9.99;
export const YEARLY_PRICE = 39.99;
export const YEARLY_PER_MONTH = (YEARLY_PRICE / 12).toFixed(2);
export const YEARLY_SAVING = (MONTHLY_PRICE * 12 - YEARLY_PRICE).toFixed(2);

export const formatPrice = (amount) => `£${Number(amount).toFixed(2)}`;

// The plan a visitor picked before sign-up (/pricing links to /sign-up?plan=yearly|monthly).
// The ?plan= param doesn't survive the trip to the Plan step — step changes navigate
// without the query string and Google sign-up is a full redirect — so the email step
// remembers it for this tab and the Plan step falls back to it.
const REQUESTED_PLAN_KEY = 'sk-trial-requested-plan';
const PLANS = ['monthly', 'yearly'];

export const validPlan = (plan) => (PLANS.includes(plan) ? plan : null);

// Set (or clear, when the visitor came in without a plan) at the start of the flow.
export const rememberRequestedPlan = (plan) => {
    try {
        if (validPlan(plan)) sessionStorage.setItem(REQUESTED_PLAN_KEY, plan);
        else sessionStorage.removeItem(REQUESTED_PLAN_KEY);
    } catch { /* private browsing - falls back to monthly */ }
};

export const readRequestedPlan = () => {
    try {
        return validPlan(sessionStorage.getItem(REQUESTED_PLAN_KEY));
    } catch {
        return null;
    }
};
